module.exports = __webpack_public_path__ + "img/ceb.7c51e388.png";